export default {
  id: 242,
  title: 'Target #242 - Orbital Tiles',
  url: 'https://cssbattle.dev/play/242',
  colors: ['#FDFFE9', '#D95362', '#2D3464'],
  solution:
    '<i a><i b><i c><style>i[a],i[b]{width:150;height:150;background:#d95362}body{background:#fdffe9}i{position:fixed}i[a]{top:75;left:125}i[b]{top:-75;left:-25;border-radius:1in;box-shadow:0 150px #2d3464,0 300px #d95362,150px 0 #2d3464,150px 300px #2d3464,300px 0 #d95362,300px 150px #2d3464,300px 300px #d95362}i[c]{top:0;left:50;width:260;height:260;border:20px solid #fdffe9',
}
